import React, { useState, useEffect } from "react";
import opportunityImg from "../../../assets/opportunity-img.svg";
import loader from "../../../assets/loader.svg";
import AxiosInstance from "../../../utils/axiosInstance";
import { useNavigate } from "react-router-dom";
import ShowFavoritesModal from "../../Model/showFavoratiesModel";

const MySavedOpportunitiesComponent = ({ selectedState, storedState }) => {
  const [dotData, setDotData] = useState([]);
  const [projectData, setProjectData] = useState([]);
  const [favLoader, setFavLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [data, setData] = useState([]);
  const [APICall, setAPICAll] = useState(false);

  const getAllFavorite = (state) => {
    setFavLoader(true);
    setAPICAll(false);
    AxiosInstance.get(
      `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_GET_ALL_FAVORITES}?state_id=${state.value}`
    )
      .then((response) => {
        const data = response.data?.data;
        if (data) {
          setDotData(data?.dot || []);
          setProjectData(data?.project || []);
        } else {
          setDotData([]);
          setProjectData([]);
        }
        setFavLoader(false);
      })
      .catch((error) => {
        console.error(error?.message);
        setFavLoader(false);
      });
  };

  useEffect(() => {
    const state = selectedState || storedState;
    if (state) {
      getAllFavorite(state);
    }
  }, [selectedState, storedState]);

  useEffect(() => {
    const state = selectedState || storedState;
    if (APICall) {
      getAllFavorite(state);
    }
  }, [APICall]);

  const handleNavigate = (type, data) => {
    setModalType(type);
    setData(data);
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleApiCall = () => {
    setAPICAll(true);
    setShowModal(false);
  };

  return (
    <div className="card w-100 h-100 bg-white rounded-3 shadow-sm mb-4 border-0">
      <div className="card-header g-0 m-0 p-0 overflow-hidden border-bottom border-light border-2">
        <div className="row g-0">
          <div className="col g-0">
            <h3 className="p-3 mb-0 pb-0 point-22 text-uppercase text-primary fw-bold">
              My Saved Opportunities
            </h3>
          </div>
          <div className="col-auto bg-secondary">
            <div className="rounded-pill bg-secondary w-100">
              <div className="d-flex flex-column justify-content-center">
                <img
                  src={opportunityImg}
                  alt="icon"
                  className="header-icon m-2"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card-body p-3">
        {!favLoader ? (
          <ul
            className="list-group py-0 mh-my-parent pe-2"
            style={{
              maxHeight: "250px",
              minHeight: "20vh",
              overflow: "auto",
              scrollbarColor: "#0D2C4F #9FAFCA", // Only works in Firefox
            }}
          >
            {/* DOT data */}
            {dotData.length > 0 &&
              dotData.map((data, i) => (
                <li
                  className="list-group-item p-0 mb-2 d-flex justify-content-between align-items-start bg-light border border-1 rounded-0"
                  key={`dot-${i}`}
                >
                  <div className="container-fluid g-0">
                    <div className="row m-0 g-0">
                      <div className="col p-2">
                        <div className="point-16 lh-sm text-primary fw-bold">
                          Call Order: {data?.call_order || "-"}
                        </div>
                        <div className="point-16 lh-sm text-primary">
                          {data?.Ldescription || "-"}
                        </div>
                      </div>
                      <div className="col-auto">
                        {data?.type && (
                          <div
                            className="red-arrow-bg p-4 d-block h-100 w-100 text-decoration-none"
                            role="button"
                            onClick={() => handleNavigate(data?.type, data)} // Call function instead of redirect
                            style={{ cursor: "pointer" }}
                          >
                            &nbsp;
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </li>
              ))}

            {/* Project data */}
            {projectData.length > 0 &&
              projectData.map((data, i) => (
                <li
                  className="list-group-item p-0 mb-2 d-flex justify-content-between align-items-start bg-light border border-1 rounded-0"
                  key={`project-${i}`}
                >
                  <div className="container-fluid g-0">
                    <div className="row m-0 g-0">
                      <div className="col p-2">
                        <div className="point-16 lh-sm text-primary fw-bold">
                          Title: {data?.project_title || "-"}
                        </div>
                        <div className="point-16 lh-sm text-primary">
                          {data?.project_description || "-"}
                        </div>
                      </div>
                      <div className="col-auto">
                        {data?.page_type && (
                          <div
                            className="red-arrow-bg p-4 d-block h-100 w-100 text-decoration-none"
                            role="button"
                            onClick={() =>
                              handleNavigate(data?.page_type, data)
                            } // Call function instead of redirect
                            style={{ cursor: "pointer" }}
                          >
                            &nbsp;
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </li>
              ))}

            {/* Empty State */}
            {dotData.length === 0 && projectData.length === 0 && (
              <div className="d-md-flex justify-content-center text-muted py-3">
                No Data Found.
              </div>
            )}
          </ul>
        ) : (
          <div className="loader text-center">
            <img src={loader} alt="loading" />
          </div>
        )}
      </div>
      {showModal && (
        <ShowFavoritesModal
          open={showModal}
          type={modalType}
          handleModalClose={handleModalClose}
          data={data}
          handleAPIcall={handleApiCall}
        />
      )}
    </div>
  );
};

export default MySavedOpportunitiesComponent;
